import {useState, useEffect} from 'react';
import {Grid, Button,TextField, CircularProgress} from '@mui/material'
import CancelIcon from '@mui/icons-material/Cancel';
import { useDispatch, useSelector } from 'react-redux';
import { referBackOrderAPI } from 'api/OmsOrdermgmtWebServices';
import SuccessMessage from 'core/components/SuccessMessage';
import ErrorMessage from 'core/components/ErrorMessage';
import { updatePharmaorderObj, setPharmaorderApproveorderModal } from 'store/slice/PharmaSlice';


export default function ReferbackActionImpl(){
    const dispatch = useDispatch();
    const [errorMessage, setErrorMessage] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    const [apiInProgress, setApiInProgress] = useState(false);
    const [comment, setComment] = useState('');

    const {pharmaorderObj} = useSelector((state)=>state.pharmaslice.pharmaorderDashboard)

    const handleCommentChange = (event) => {
        setErrorMessage('');
        setComment(event.target.value); // Update state with the input value
    };

    const referBackSuccess = (response) =>{
        setApiInProgress(false);
        dispatch(updatePharmaorderObj(response.pharmaorderInfo));
        response.productInfoList.list.map(productObj => dispatch(updatePharmaorderObj(productObj)));
        dispatch(setPharmaorderApproveorderModal(false));
        setSuccessMsg('Order is successfully referred back.');
    }
    const referBackFailure = (errorMessage) =>{
        setApiInProgress(false);
        setErrorMessage(errorMessage);
    }
    const handleReferBack = () =>{
        if (comment==='')   {
            setErrorMessage('Comment is mandatory to \'Refer Back\' Order.');
            return;
        }

        setApiInProgress(true);
        referBackOrderAPI(
            {orderId:pharmaorderObj.id, comment:comment},
            referBackSuccess, referBackFailure
        )
    }
    const getComponent = () =>{
        if (apiInProgress) return <Grid item lg={4} xs={4} align="center"><CircularProgress/></Grid>
        if (successMsg!=='') return <Grid item align="right"  padding={1}><SuccessMessage message={successMsg} /></Grid>
        if (errorMessage!=='') {
            return  <><Grid item lg={4} xs={12} align="right"  padding={1}><ErrorMessage message={errorMessage} /></Grid>
                    <Grid item lg={8} xs={12} align="right"><Button variant="contained" color="error" onClick={handleReferBack} startIcon={<CancelIcon />} disabled={comment===''?true:false}>Refer Back</Button></Grid>
                    </>
        }
        return <Grid item lg={12} xs={4} align="right"><Button variant="contained" color="error" onClick={handleReferBack} startIcon={<CancelIcon />} disabled={comment===''?true:false}>Refer Back</Button></Grid>
    }
    return (
        <Grid container direction="row" sx={{justifyContent: "center",alignItems: "center", backgroundColor:'white'}} padding={5} >
            <Grid item lg={12} xs={12} sx={{paddingBottom:2}}>
                <TextField
                    label="Enter refer back Reason"
                    multiline
                    variant="filled" // You can use "outlined", "filled", or "standard"
                    fullWidth // Optional: makes the TextField take the full width of the parent container
                    onChange={handleCommentChange}
                    sx={{
                        '& .MuiInputBase-input': {
                            fontSize: 16,
                            '@media (min-width:600px)': {
                                minHeight: 'calc(1.5em * 2)',
                            },
                            '@media (max-width:600px)': {
                                minHeight: 'calc(1.5em * 5)',
                            },
                        },
                    
                    }}
                />
            </Grid>
            
            {getComponent()}
        </Grid>
    )
}